// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';

import PlaceholderRow from 'src/Domain/Placeholder/PlaceholderRow';

import styles from './PlaceholderList.scss';

type Props = {
  count: number,
};

export default function PlaceholderList({ count }: Props): React.MixedElement {
  return (
    <Base
      tagName="ul"
      listStyleType="none"
      flex
      flexCol
      className={styles.container}
    >
      {Array(count)
        .fill('placeholder')
        .map((item, idx) => (
          <PlaceholderRow
            tagName="li"
            key={`suggestion-placeholder-${idx}`} // eslint-disable-line react/no-array-index-key
          />
        ))}
    </Base>
  );
}
